import { useState } from 'react';
import { List, Button } from 'antd';

const DataList = ({ data }) => {
  const [expanded, setExpanded] = useState(false);
  const MAX_VISIBLE_ITEMS = 3;

  const handleShowOrFold = () => {
    setExpanded(!expanded);
  };

  const visibleData = expanded ? data : data.slice(0, MAX_VISIBLE_ITEMS);
  const hasMore = data.length > MAX_VISIBLE_ITEMS;

  return (
    <List
      dataSource={visibleData}
      itemPadding={3}
      renderItem={item => (
        <List.Item style={{backgroundColor : '#F2F2F2', borderRadius: '8px',  padding: '6px', /*width: '180px',*/  display: 'block'}}>
          {item}
        </List.Item>
      )}
      pagination={false}
      footer={hasMore ? (
        <div style={{padding: '0'}}>
          <Button type="link" onClick={handleShowOrFold}>
              {expanded ? "Fold Up" : "Show More"}
          </Button>
        </div>
      ) : null}
    />
  );
};

export default DataList;